var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-back",on:{"click":_vm.handleGoCart}},[_c('span',{staticClass:"iconfont icon-chexiao"})])
}
var staticRenderFns = []

export { render, staticRenderFns }